<template>
    <div class="row" v-if="turma">
        <div class="col-12 col-sm-12 col-md-12">
            <CardRh :processando="processando">
                <div class="turma-aula-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="searchAulaTurma" class="form-label">Pesquisar</label>
                                <input id="searchAulaTurma" v-model="search" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Pesquisar" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="pelotaoAulaTurma" class="form-label">Pelotao</label>
                                <input id="pelotaoAulaTurma" v-model="pelotao" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Pelotao" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="disciplinaAulaTurma" class="form-label">Disciplina</label>
                                <input id="disciplinaAulaTurma" v-model="disciplinaFiltro" @keyup="apertouEnter"
                                    type="text" class="form-control form-control-solid" placeholder="Disciplina" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Disciplina</th>
                            <th style="max-width:180px">Pelotao</th>
                            <th style="max-width:180px">CH</th>
                            <th style="max-width:180px">CH Prevista</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaDisciplinaService from "@/service/v1/sigap/AulaDisciplinaService";

const authStore = namespace('auth');

@Options({
    name: "InserirFaltaMatricula",
    components: { CardRh, KDataTable },
})
export default class InserirFaltaMatricula extends Vue {
    @Prop() readonly turma!: any;

    @authStore.Getter
    public perfis!: any;

    public config: any;
    public service = new AulaDisciplinaService();
    public processando = false;
    public reloadDatatable = false;
    public search = '';
    public pelotao = '';
    public disciplinaFiltro = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.pelotao = '';
        this.disciplinaFiltro = '';
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.config.ajax = {
            url: this.service.getApiUrl() + '/Relatorio/Aula',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turma?.id,
                    disciplina: this.disciplinaFiltro,
                    pelotao: this.pelotao,
                    search: this.search,
                };
                return dados;
            }
        }; 
        this.config.columns = [
            { data: 'disciplina', name: 'disciplina',  orderable: false },
            { data: 'pelotao', name: 'pelotao', class: 'text-center',  orderable: false  },
            { data: 'count', name: 'count', class: 'text-center',  orderable: false  },
            { data: 'cargaHoraria', name: 'cargaHoraria', class: 'text-center',  orderable: false  },
        ];
    }
}
</script>

<style scoped>
.turma-aula-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.btn-flex-full {
    max-width: 100%;
    min-width: 100%;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
